'use memo'

import { useState } from 'react'
import type { SnEvent } from '@sportninja/common/features/event/types'

/**
 * Open/close state for the add-edit modal. `editingEvent` is null in add mode
 * and the event being edited otherwise — the modal derives its mode from it.
 */
export const useEventModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [editingEvent, setEditingEvent] = useState<SnEvent | null>(null)

  return {
    isOpen,
    editingEvent,
    openAdd: () => {
      setEditingEvent(null)
      setIsOpen(true)
    },
    openEdit: (event: SnEvent) => {
      setEditingEvent(event)
      setIsOpen(true)
    },
    close: () => {
      setIsOpen(false)
      setEditingEvent(null)
    },
  }
}
